// extracted by mini-css-extract-plugin
export default {"Image":"styles_Image__fzk1Y"};